module.exports = __webpack_public_path__ + "assets/8.png";


//////////////////
// WEBPACK FOOTER
// ./images/8.png
// module id = 703
// module chunks = 0